import { useLocation as useLocationHook } from 'react-router-dom';

const useLocation = () => {
  const location = useLocationHook();
  return {
    state: location.state,
    pathname: location.pathname,
    search: location.search,
    hash: location.hash,
  };
};

export default useLocation;
